import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getUserV2 } from './api';
import { UserDTO } from './dto/UserDTO';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<UserDTO>, 'enabled' | 'retry' | 'onSuccess'>;

export default function useUser(options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data: user, isFetching } = useQuery<UserDTO>(['user'], () => getUserV2(), {
    enabled: true,
    onError: error => {
      toast.error(t('message.title.error.get.inventory'));
    },
    ...options,
  });

  return { user: user, isFetching, getUserV2 };
}
